import {Button, Form, Modal, message} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, {useEffect, useState} from "react";
import api from "../../api";
import {useTranslations} from "../../lang";

export default function FeedbackModal({open, onCancel, errorContext}) {
    const [form] = Form.useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {translate} = useTranslations();

    useEffect(() => {
        if (!open) {
            form.resetFields();
        }
    }, [open, form]);

    function handleSubmit() {
        form.validateFields().then(values => {
            setIsSubmitting(true);
            api.submitFeedback({
                message: values.message,
                frontend_path: window.location.pathname,
                request_path: errorContext?.request_path || null,
                request_method: errorContext?.request_method || null,
                request_body: errorContext?.request_body || null,
            }).then(() => {
                message.success(translate('Feedback verstuurd'));
                form.resetFields();
                onCancel();
            }).catch(() => {
                message.error(translate('Er ging iets mis bij het versturen'));
            }).finally(() => {
                setIsSubmitting(false);
            });
        });
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={(
                <Button type="primary" onClick={handleSubmit} loading={isSubmitting}>
                    {translate('Versturen')}
                </Button>
            )}
        >
            <h2>{translate('Aan Stef melden')}</h2>
            <Form form={form} layout="vertical">
                <Form.Item
                    name="message"
                    label={translate('Wat lukt er niet?')}
                    rules={[{required: true, message: translate('Vul een bericht in')}]}
                >
                    <TextArea
                        autoSize={{minRows: 3, maxRows: 8}}
                        placeholder={translate('Beschrijf wat er mis ging...')}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}
